import { createStore, applyMiddleware, compose } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunk from 'redux-thunk'
import rootReducer from '../rootReducer'
import WSocket from '../components/websocket'

/* syncs our browserHistory with our store and must be exported so we can use it within our routes later */

const initialState = {}
const enhancers = []
const middleware = [
  thunk,
  WSocket,
]

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__
  const { logger } = require('redux-logger') // eslint-disable-line global-require
  middleware.push(logger)

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension())
  }
}

const composedEnhancers = () => {
  const isProduction = process.env.NODE_ENV === 'production'

  return isProduction ?
    compose(applyMiddleware(...middleware))
    :
    composeWithDevTools(applyMiddleware(...middleware))
}

/*
    creates a store using the Redux createStore function.
    It accepts a rootReducer, initialState and an enhancer
*/
const store = createStore(
  rootReducer,
  initialState,
  composedEnhancers()
)

export default store



// WEBPACK FOOTER //
// ./src/store/index.js